import React, { useState } from "react";

const FAQ = () => {
  const faqData = [
    {
      question: "Quels produits trouvez-vous chez Almoune ?",
      answer:
        "Almoune propose une large selection de produits libanais et orientaux : pain libanais frais, zaatar, tahini, halawa, cafe Najjar, boissons orientales (Junet, Al-Rabih), condiments, conserves, fruits secs, douceurs (Hallab 1881, Gandour) et biscuits. Nous avons aussi des vins libanais selectionnes.",
    },
    {
      question: "Comment passer une commande ?",
      answer:
        "Parcourez la boutique, ajoutez vos produits au panier en cliquant sur \"Ajouter\". Une fois votre panier pret, rendez-vous dans le panier puis cliquez sur \"Commander\". Renseignez votre adresse de livraison, choisissez un creneau et validez. Les produits sont reserves pendant 20 minutes le temps de finaliser votre commande.",
    },
    {
      question: "Quels sont les frais de livraison ?",
      answer:
        "Les frais dependent de votre code postal. Pour Paris et proche banlieue (75xxx-95xxx) : 4,90 EUR. Pour le reste de la France metropolitaine (01xxx-99xxx) : 7,90 EUR. La livraison est offerte a partir de 49 EUR pour Paris et 79 EUR pour la France.",
    },
    {
      question: "Y a-t-il un minimum de commande ?",
      answer:
        "Oui, selon votre zone de livraison. Pour la France metropolitaine, le minimum est de 25 EUR. Pour Paris, il n'y a pas de minimum general, mais un minimum de 30 EUR s'applique si votre panier contient des produits surgeles (frais de transport specifiques). Les produits frais peuvent aussi avoir un minimum selon la zone.",
    },
    {
      question: "Puis-je commander des produits surgeles ?",
      answer:
        "Oui, certains produits surgeles sont disponibles selon votre zone de livraison. Un minimum de 30 EUR de produits surgeles est requis pour couvrir les frais de transport adapte. Consultez les zones de livraison compatibles avec les surgeles depuis la page de paiement.",
    },
    {
      question: "Y a-t-il des limites de quantite par produit ?",
      answer:
        "Certains produits ont une limite maximale par commande. Par exemple, le pain libanais est limite a 3 sacs par commande. La limite est indiquee sur chaque fiche produit. Si vous atteignez le maximum, le panier vous en informera.",
    },
    {
      question: "Quels moyens de paiement acceptez-vous ?",
      answer:
        "Nous acceptons le paiement par carte bancaire (Visa, Mastercard, CB), PayPal et le paiement a la livraison (especes ou carte selon disponibilite).",
    },
    {
      question: "Comment contacter Almoune ?",
      answer:
        "Vous pouvez nous joindre par telephone au +33 9 81 39 14 33 ou via la page Contact du site. Notre equipe repond a vos questions sur les produits, les commandes et la livraison.",
    },
    {
      question: "Puis-je modifier ou annuler ma commande ?",
      answer:
        "Une fois commande, les stocks sont deduits. Contactez-nous rapidement par telephone au +33 9 81 39 14 33 pour toute modification ou annulation. Nous ferons notre possible selon l'avancement de la preparation.",
    },
    {
      question: "Quels sont les delais de livraison ?",
      answer:
        "La livraison est assuree par des transporteurs partenaires (livreurs) que vous selectionnez lors du paiement. Les delais indiques correspondent a ceux de chaque transporteur, et les frais dependent de votre code postal.",
    },
    {
      question: "Ou se trouve la boutique Almoune ?",
      answer:
        "Notre boutique est situee au 2 Place du Rouillon, 91000 Evry-Courcouronnes. Vous pouvez nous rendre visite aux horaires d'ouverture ou commander en ligne pour une livraison a domicile.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <div className="row">
        <div className="col-md-12 mb-6">
          <div className="section-head text-center mt-8">
            <h1 className="h3style" style={{ color: "green" }}>
              Questions frequentes
            </h1>
            <div className="wt-separator bg-primarys"></div>
            <div className="wt-separator2 bg-primarys"></div>
          </div>
        </div>
      </div>
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div className="faq-item" key={index}>
            <button className="faq-question" onClick={() => toggle(index)}>
              <span>{item.question}</span>
              <span className={`faq-icon ${openIndex === index ? "open" : ""}`}>+</span>
            </button>
            <div className={`faq-answer ${openIndex === index ? "show" : ""}`}>
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
